import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";

export default [
  {
    icon: <FaFacebookF />,
    url: "https://Facebook.com/Threeinvaders",
  },
  {
    icon: <FaTwitter />,
    url: "https://twitter.com/abdulsrisaleem",
  },
  {
    icon: <FaInstagram />,
    url: "https://www.instagram.com/prof_abdulrauf",
  },
  {
    icon: <FaLinkedinIn />,
    url: "https://www.linkedin.com/in/saleemabdulrauf/",
  },
  {
    icon: <FaYoutube />,
    url: "https://youtube.com",
  },
];
